// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"a96995a9","137":"aa06054c","233":"ea744936","241":"428209cb","481":"a2900dbc","518":"8f052f4c","657":"56c1c31f","658":"1ea8c07e","670":"700248d1","741":"e657ec37","822":"a45cc51c","858":"a9f53573","865":"6c9a888d","900":"5443b984"}[chunkId] + ".chunk.js";
};